import * as React from "react";
import { NavLink, Redirect } from "react-router-dom";
import { withTranslation } from "react-i18next";
import Axios, { AxiosResponse } from "axios";
import config from "../config";
import CoreComponent from "./CoreComponent";
import { t } from "i18next";
import { IHolder } from "../interfaces";
import HolderModal from "../components/HolderModal";
import { connect } from "react-redux";
import { arrayToFormData } from "../utils/functions";
import { addIds } from "../actions/payment";
import { toast } from "react-toastify";
import { change } from "../actions/search";

import './css/style.css';

const CancelToken = Axios.CancelToken;
let cancel: any;

interface IState {
    holders: IHolder[];
    date_from: string;
    to_date: string;
    limit: number;
    pagination: any;
    query: string;
    ids: number[];
    type: string;
    sort: string;
    isLoading: boolean;
    isOpen: boolean;
    currentPage: number;
    holder: IHolder;
}

class ArchiveHolders extends CoreComponent<any, any> {
    state: IState = {
        holders: [],
        date_from: "",
        to_date: "",
        limit: 30,
        pagination: null,
        query: "",
        ids: [],
        type: "asc",
        sort: "full_name",
        isLoading: true,
        isOpen: false,
        currentPage: 1,
        holder: null,
    };

    constructor(props: any) {
        super(props);

        this.handleModal = this.handleModal.bind(this);
    }

    componentDidMount() {
        let _this = this;

        $(".datepicker")
            .datepicker({
                startView: 1,
                minViewMode: 1,
                language: "ru",
                format: "yyyy-mm",
            })
            .on("changeDate", function (e: any) {
                if (e.target.name == "date_from")
                    _this.setState(
                        {
                            date_from: e.target.value,
                        },
                        () => {
                            _this.loadHolders();
                        }
                    );
                else
                    _this.setState(
                        {
                            to_date: e.target.value,
                        },
                        () => {
                            _this.loadHolders();
                        }
                    );
            });

        $(".operator").select2();
    }

    async componentWillMount() {
        this.loadHolders();
        console.log(this.props.search);

    }

    async loadHolders(search: string = null) {
        cancel && cancel();

        if (!search && this.props.search)
            search = this.props.search;

        this.setState(
            {
                isLoading: true,
            },
            async () => {
                let url = null;
                let limit = this.state.limit * this.state.currentPage;

                url = `${config.api}/archive/index?limit=${limit}`;

                if (this.state.date_from) {
                    url += `&date_from=${this.state.date_from}`;
                }

                if (this.state.to_date) {
                    url += `&to_date=${this.state.to_date}`;
                }

                if (this.state.sort) {
                    url += `&sort=${this.state.sort}`;
                }

                if (this.state.type) {
                    url += `&type=${this.state.type}`;
                }

                if (search) {
                    url += `&search=${search}`;
                }

                if (this.props.match.params.id) {
                    url += `&producer_id=${this.props.match.params.id}`;
                }

                let res = await Axios.get(url, {
                    cancelToken: new CancelToken(function executor(c) {
                        cancel = c;
                    })
                });

                if (!this.isUnmounted && res) {
                    this.setState({
                        holders: res.data.models,
                        date_from: res.data.date_from,
                        to_date: res.data.to_date,
                        pagination: res.data.pagination,
                        type: res.data.type,
                        sort: res.data.sort,
                        isLoading: false,
                    });
                }
            }
        );
    }

    setOrder(sort: string) {
        this.setState(
            {
                type:
                    this.state.sort != sort
                        ? (sort == "full_name" ? "asc" : "desc")
                        : this.state.type == "asc"
                            ? "desc"
                            : "asc",
                sort,
            },
            () => {
                this.loadHolders();
            }
        );
    }

    showMore() {
        this.setState(
            {
                currentPage: this.state.currentPage + 1,
            },
            () => {
                this.loadHolders();
            }
        );
    }

    handleModal() {
        this.setState(
            {
                isOpen: !this.state.isOpen,
            },
            () => {
                this.loadHolders();
            }
        );
    }

    async createReport() {
        if (this.state.ids.length > 0) {
            let ids = arrayToFormData({
                ids: this.state.ids,
                date_from: this.state.date_from,
                to_date: this.state.to_date,
            });
            let response: AxiosResponse = await Axios.post(
                `${config.api}/artist/report`,
                ids,
                { responseType: "blob" }
            );

            const url = window.URL.createObjectURL(
                new Blob([response.data], { type: "application/pdf" })
            );
            const link = document.createElement("a");

            link.href = url;

            link.setAttribute(
                "download",
                "Отчет с " +
                this.state.date_from +
                " по " +
                this.state.to_date +
                ".pdf"
            ); //or any other extension

            document.body.appendChild(link);

            link.click();
            link.remove();
        } else {
            toast("Выберите партнеров", { type: "error" });
        }
    }

    createPayment() {
        if (this.state.ids.length > 0) {
            this.props.addIds(this.state.ids).then(() => {
                this.props.history.push("/admin/create-payments");
            });
        } else {
            toast("Выберите партнеров", { type: "error" });
        }
    }

    async delete() {
        if (confirm("Вы уверены?")) {
            if (this.state.ids.length > 0) {
                let response: AxiosResponse = await Axios.post(`${config.api}/archive/delete-artist`, arrayToFormData({ id: this.state.ids }));

                if (response.data && response.data.length > 0)
                    this.setState({
                        holders: this.state.holders.filter((holder: IHolder) => !response.data.includes(holder.id.toString())),
                        ids: []
                    });

                toast("Партнеры удалены: " + response.data.length, { type: "success" });
            } else {
                toast("Выберите партнеров", { type: "error" });
            }
        }
    }

    componentWillReceiveProps(nextProps: any) {
        let { search } = nextProps;
        console.log(search);

        this.loadHolders(search);
    }

    render() {
        let { t, auth } = this.props;

        if (!auth.isAuthentificated) return <Redirect to="/login" />;



        return (
            <div className="crm-holders main-holders">
                <HolderModal
                    isOpen={this.state.isOpen}
                    handleModal={this.handleModal}
                    holder={this.state.holder}
                />
                <div className="wrapper">
                    <NavLink className="crm-holders__back" to="/admin/settings">
                        Назад
                    </NavLink>
                    <span className="crm-holders__title">{"Архивированные партнеры"}</span>
                    <div className="crm-holders__headline">
                        <div className="crm-holders__buttons">

                            <a
                                role="button"
                                onClick={() => {
                                    this.delete();
                                }}
                                style={{ margin: "0", marginRight: "15px" }}
                                className="btn-del"
                            >
                                Удалить
                            </a>
                        </div>

                        <div className="crm-holders__count">
                            <img src="img/Group 205.svg" alt="" />
                            <select
                                id="select_page"
                                style={{ width: "70px" }}
                                className="numm"
                                value={this.state.limit}
                                onChange={(e: any) => {
                                    this.setState(
                                        {
                                            limit: Number.parseInt(
                                                e.target.value
                                            ),
                                        },
                                        () => {
                                            this.loadHolders();
                                        }
                                    );
                                }}
                            >
                                <option value="15">15</option>
                                <option value="30">30</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                                <option value="200">200</option>
                                <option value="500">500</option>
                                <option value="100000">Все</option>
                            </select>

                            <span
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginLeft: "50px",
                                }}
                            >
                                Дата:
                                <div className="input-group date">
                                    <input
                                        type="text"
                                        className="form-control datepicker"
                                        autoComplete="off"
                                        name="date_from"
                                        defaultValue={this.state.date_from}
                                    />
                                    <img
                                        src="img/Icon awesome-calendar-alt.svg"
                                        alt=""
                                    />
                                    <div className="input-group-addon">
                                        <span className="glyphicon glyphicon-th"></span>
                                    </div>
                                </div>
                                <div className="block-line"></div>
                                <div className="input-group date">
                                    <input
                                        type="text"
                                        className="form-control datepicker"
                                        autoComplete="off"
                                        name="to_date"
                                        defaultValue={this.state.to_date}
                                    />
                                    <img
                                        src="img/Icon awesome-calendar-alt.svg"
                                        alt=""
                                    />
                                    <div className="input-group-addon">
                                        <span className="glyphicon glyphicon-th"></span>
                                    </div>
                                </div>
                            </span>
                        </div>
                        <div className="crm-holders__buttons">

                        </div>
                    </div>

                    <div className="crm-list">
                        <table>
                            <thead>
                                <tr>
                                    <th>
                                        <input
                                            type="checkbox"
                                            onChange={() => {
                                                if (
                                                    this.state.ids.length !=
                                                    this.state.holders.length
                                                ) {
                                                    this.setState({
                                                        ids: this.state.holders.map(
                                                            (holder: IHolder) =>
                                                                holder.id
                                                        ),
                                                    });
                                                } else {
                                                    this.setState({
                                                        ids: [],
                                                    });
                                                }
                                            }}
                                            checked={
                                                this.state.ids.length ==
                                                this.state.holders.length
                                            }
                                        />
                                    </th>
                                    <th>
                                        <a
                                            role="button"
                                            onClick={() => {
                                                this.setOrder("id");
                                            }}
                                        >
                                            ID
                                        </a>
                                    </th>
                                    <th>
                                        <a
                                            role="button"
                                            onClick={() => {
                                                this.setOrder("full_name");
                                            }}
                                        >
                                            Партнер
                                            <img
                                                src="img/Group 199.svg"
                                                alt=""
                                            />
                                        </a>
                                    </th>
                                    <th>
                                        <a
                                            role="button"
                                            onClick={() => {
                                                this.setOrder(
                                                    "composition_count"
                                                );
                                            }}
                                        >
                                            Кол-во
                                            <br />
                                            объектов
                                            <img
                                                src="img/Group 199.svg"
                                                alt=""
                                            />
                                        </a>
                                    </th>
                                    <th>
                                        <a
                                            role="button"
                                            onClick={() => {
                                                this.setOrder("views");
                                            }}
                                        >
                                            Кол-во
                                            <br /> просмотров
                                            <img
                                                src="img/Group 199.svg"
                                                alt=""
                                            />
                                        </a>
                                    </th>
                                    <th>
                                        <a
                                            role="button"
                                            onClick={() => {
                                                this.setOrder("balance");
                                            }}
                                        >
                                            Баланс{" "}
                                            <img
                                                src="img/Group 199.svg"
                                                alt=""
                                            />
                                        </a>
                                    </th>

                                    <th>
                                        <a
                                            role="button"
                                            onClick={() => {
                                                this.setOrder("paid");
                                            }}
                                        >
                                            Оплачено{" "}
                                            <img
                                                src="img/Group 199.svg"
                                                alt=""
                                            />
                                        </a>
                                    </th>
                                    <th>
                                        <a
                                            role="button"
                                            onClick={() => {
                                                this.setOrder("currency");
                                            }}
                                        >
                                            Сумма{" "}
                                            <img
                                                src="img/Group 199.svg"
                                                alt=""
                                            />
                                        </a>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {!this.state.isLoading &&
                                    this.state.holders.length == 0 && (
                                        <tr>
                                            <td colSpan={8}>
                                                {t("Ничего не найдено")}
                                            </td>
                                        </tr>
                                    )}
                                {this.state.isLoading && (
                                    <tr>
                                        <td colSpan={8}>
                                            {t("Загрузка данных")}
                                        </td>
                                    </tr>
                                )}
                                {this.state.holders.map(
                                    (holder: IHolder, i: number) => {
                                        return (
                                            <tr key={i}>
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        checked={
                                                            !!this.state.ids.find(
                                                                (id: number) =>
                                                                    id ==
                                                                    holder.id
                                                            )
                                                        }
                                                        onChange={(e: any) => {
                                                            if (
                                                                e.target.checked
                                                            ) {
                                                                this.setState({
                                                                    ids: [
                                                                        ...this
                                                                            .state
                                                                            .ids,
                                                                        holder.id,
                                                                    ],
                                                                });
                                                            } else {
                                                                this.setState({
                                                                    ids: this.state.ids.filter(
                                                                        (
                                                                            id: number
                                                                        ) =>
                                                                            id !=
                                                                            holder.id
                                                                    ),
                                                                });
                                                            }
                                                        }}
                                                    />
                                                </td>
                                                <td>{holder.id}</td>
                                                <td>
                                                    <NavLink
                                                        to={"/admin/archive/holder/" + holder.id}
                                                        className="d-inline"
                                                    >
                                                        {holder.full_name}
                                                    </NavLink>

                                                </td>
                                                <td>
                                                    {holder.composition_count}
                                                </td>
                                                <td>{holder.views}</td>
                                                <td className={Number.parseFloat(
                                                    holder.balance
                                                ) >= 0 ? "text-green" : "text-red"}>
                                                    $
                                                    {Number.parseFloat(
                                                        holder.balance
                                                    ).toFixed(3).slice(0, -1)}
                                                </td>
                                                <td className="text-red">
                                                    $
                                                    {Number.parseFloat(
                                                        holder.payed
                                                    ).toFixed(3).slice(0, -1)}
                                                </td>
                                                <td className="text-green">
                                                    $
                                                    {Number.parseFloat(
                                                    holder.doxod
                                                ).toFixed(3).slice(0, -1)}
                                                </td>
                                            </tr>
                                        );
                                    }
                                )}
                            </tbody>
                        </table>
                        <div className="text-center p-3">
                            {this.state.holders.length > 0 && this.state.holders.length < this.state.pagination?.totalCount && (
                                <a
                                    role="button"
                                    className="spec-color fs-12"
                                    onClick={() => {
                                        this.showMore();
                                    }}
                                >
                                    Показать ещё...
                                </a>
                            )}
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

export default connect(
    function (state: any) {
        return {
            auth: state.auth,
            search: state.search
        };
    },
    { addIds, change }
)(withTranslation()(ArchiveHolders));
